import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(private afAuth: AngularFireAuth, private envService: EnvService) { }

  public async loginWithPhone(phoneNumber: string, appVerifier: any, mockResponse: boolean): Promise<any> { // Todo: fix types
    // mockResponse = true // Todo: remove: #feb11
    if (mockResponse) {
      console.log('env is q1, returning mock firebase response'); // Todo: Remove:
      const mockOTPRes = await new Promise((resolve, reject) => {
        resolve({
          confirm: function(otp:string) {
            return true;
          }
        })
      })
      return mockOTPRes;
    }
    else {
      try {
        const result = await this.afAuth.signInWithPhoneNumber(phoneNumber, appVerifier);
        console.log('result from loginWithPhone', result); // Todo: remove:
        return result;
      } catch (error) {
        console.error('error during loginWithPhone', error);
        throw new Error('loginWithPhone ERROR')
      }
    }
  }

  public logout() {
    return this.afAuth.signOut();
  }

  public getUser() {
    return this.afAuth.user;
  }
}
